module.exports = __webpack_public_path__ + "crm-market.svg?0acc2d04ecc91ed000e42663824dcf36";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crm-market.svg
// module id = 119
// module chunks = 0